import { render, staticRenderFns } from "./cancelPenaltyData.vue?vue&type=template&id=00dc108f&scoped=true&"
import script from "./cancelPenaltyData.vue?vue&type=script&lang=js&"
export * from "./cancelPenaltyData.vue?vue&type=script&lang=js&"
import style0 from "./cancelPenaltyData.vue?vue&type=style&index=0&id=00dc108f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc108f",
  null
  
)

export default component.exports